import React from 'react';
import { I18n } from 'react-redux-i18n';
import { List, ListSubheader, ListItemText, ListItem, Tooltip, IconButton } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {
  editIcon, deleteIcon,
} from '../../../app/utils/icons';
import WorkflowDynamicFields from './WorkflowDynamicFields';


export default (props) => {

  return (
    <div>

      <List
        component="nav"
      >
        {props.phases.map((item, i) => (
          <div>
            <ListItem>
              <ListItemText inset primary={item.name} />
              <Tooltip title={I18n.t('button.delete')}>
                <IconButton aria-label="Delete" onClick={() => props.onRemovePhase(item, i)}>
                  {deleteIcon}
                </IconButton>
              </Tooltip>
              <Tooltip title={I18n.t('button.add_dynamic_fields')}>
                <IconButton aria-label={I18n.t('fields.add_dynamic_fields')} onClick={() => props.onAddDynamicField(item, i)}>
                  {editIcon}
                </IconButton>
              </Tooltip>
              <IconButton onClick={event => props.handleOpenClose((item))}>
                {item.open ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </ListItem>
            <Collapse in={!item.open} timeout="auto" unmountOnExit>
              <WorkflowDynamicFields items={item.fieldsList} lstComponents={props.lstComponents} onChangeItem={props.forceRender} onRemoveDynamicField={props.onRemoveDynamicField}/>
            </Collapse>
          </div>
        ))}
      </List>
    </div>
  );

};




// WEBPACK FOOTER //
// ./src/components/tracker/Flow/WorkflowPhases.js